import type { TreeMapFilterCardProps } from "./tree-map-filter-card.type";

import { Collapse } from "antd";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import TreeMapFilterItem from "../tree-map-filter-item";

import { useTreeMapFilterCard } from "./tree-map-filter-card.hook";

import "./tree-map-filter-card.style.less";

const TreeMapFilterCard = (props: TreeMapFilterCardProps) => {
  const { t } = useTranslation();

  const {
    type,
    titleType,
    count,
    checked,
    onToggle,
    showArrow,
    hideSubFilters,
    subFilters,
  } = useTreeMapFilterCard(props);

  const title = (
    <TreeMapFilterItem
      title={t(`global:treeMap.filterByType.${titleType}`)}
      count={count}
      checked={checked}
      onToggle={() => onToggle(checked)}
    />
  );

  return (
    <Collapse
      defaultActiveKey={type}
      items={[{ key: type, label: title, showArrow, children: subFilters }]}
      collapsible={
        // prevent clickable zone with `icon` value
        !showArrow ? "icon" : undefined
      }
      className={classNames("tree-map-filter-card", {
        "-no-arrow": !showArrow,
        "-no-content": hideSubFilters,
      })}
      size="small"
      ghost
    />
  );
};

export default TreeMapFilterCard;
